// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BuJPeejBF3OLzsQB_0LR {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: max(var(--status-bar-height), var(--safe-bottom, 0px));
  background: var(--status-bar-background, #48494a);
  transition: background-color 0.9s ease;
  position: relative;
  padding: 8px;
  padding-bottom: max(8px, var(--safe-bottom, 0px));
  padding-left: max(8px, var(--safe-left, 0px));
  padding-right: max(8px, var(--safe-right, 0px));
}
.WBlzZscDHNW38ls5dsDh,
.Vq3nkZ1NafGDrz1aCyQp {
  display: flex;
  z-index: 2;
  height: 100%;
}
.e3eMuOsBra31a0vbTj1T {
  display: flex;
  justify-content: space-between;
  width: 88px;
}
.cxBjwe9iN1vSz7a8ADmP {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: var(--white-color);
}
.Q8YWCvSFFwfJPzkkTurR {
  display: flex;
  line-height: 14px;
  align-items: baseline;
  gap: 3px;
  font-weight: 800;
  font-family: 'Futura PT Cond';
}
.RoHFaVMWph2hyCbCOWGu {
  font-size: 20px;
}
._8WoHqdME1FR9D_ASH9IF {
  font-size: 12px;
  text-transform: uppercase;
}
@media (max-width: 430px) {
  ._8WoHqdME1FR9D_ASH9IF {
    font-size: 13px;
  }
}
.tDA4DpVP5E4G3xiNrDtA {
  font-size: 12px;
  font-weight: 400;
  padding-left: 2px;
  font-family: 'Futura PT';
  text-transform: uppercase;
  line-height: 10px;
  height: 9px;
}
`, "",{"version":3,"sources":["webpack://./src/features/navigation/components/StatusBar/StatusBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,8DAA8D;EAC9D,iDAAiD;EACjD,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD,6CAA6C;EAC7C,+CAA+C;AACjD;AACA;;EAEE,aAAa;EACb,UAAU;EACV,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".statusBarContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: max(var(--status-bar-height), var(--safe-bottom, 0px));\n  background: var(--status-bar-background, #48494a);\n  transition: background-color 0.9s ease;\n  position: relative;\n  padding: 8px;\n  padding-bottom: max(8px, var(--safe-bottom, 0px));\n  padding-left: max(8px, var(--safe-left, 0px));\n  padding-right: max(8px, var(--safe-right, 0px));\n}\n.leftSection,\n.rightSection {\n  display: flex;\n  z-index: 2;\n  height: 100%;\n}\n.actionsGroup {\n  display: flex;\n  justify-content: space-between;\n  width: 88px;\n}\n.balanceContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  color: var(--white-color);\n}\n.balanceAmountRow {\n  display: flex;\n  line-height: 14px;\n  align-items: baseline;\n  gap: 3px;\n  font-weight: 800;\n  font-family: 'Futura PT Cond';\n}\n.balanceAmount {\n  font-size: 20px;\n}\n.balanceCurrency {\n  font-size: 12px;\n  text-transform: uppercase;\n}\n@media (max-width: 430px) {\n  .balanceCurrency {\n    font-size: 13px;\n  }\n}\n.balanceCaption {\n  font-size: 12px;\n  font-weight: 400;\n  padding-left: 2px;\n  font-family: 'Futura PT';\n  text-transform: uppercase;\n  line-height: 10px;\n  height: 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBarContainer": `BuJPeejBF3OLzsQB_0LR`,
	"leftSection": `WBlzZscDHNW38ls5dsDh`,
	"rightSection": `Vq3nkZ1NafGDrz1aCyQp`,
	"actionsGroup": `e3eMuOsBra31a0vbTj1T`,
	"balanceContainer": `cxBjwe9iN1vSz7a8ADmP`,
	"balanceAmountRow": `Q8YWCvSFFwfJPzkkTurR`,
	"balanceAmount": `RoHFaVMWph2hyCbCOWGu`,
	"balanceCurrency": `_8WoHqdME1FR9D_ASH9IF`,
	"balanceCaption": `tDA4DpVP5E4G3xiNrDtA`
};
export default ___CSS_LOADER_EXPORT___;
